import styled, { css } from 'styled-components'

const Container = styled.div`
  position: fixed;
  width: 100vw;
  height: 80px;
  z-index: 6999;
  opacity: 1;
  top: ${props => props.emrIntegrationToolBarVisible ? '44px' : '0px'};
  ${props => props.dictation && css`
    background: #ccc,
    boxShadow: rgb(0 0 0 / 20%) 0px 0px 10px
  `};

  ${props => !props.dictation && css`
    background: #F2F5F0
  `};
`

export { Container }
